import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { useLang } from "../i18n";
import api from "../api";

const pad = (n) => String(n).padStart(2, "0");

const FlashPromo = () => {
  const { t } = useLang();
  const [promo, setPromo] = useState(null);
  const [left, setLeft] = useState(null);

  useEffect(() => {
    api.get("/promo/flash").then(({ data }) => {
      if (data.active) setPromo(data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!promo) return;
    const tick = () => {
      const diff = new Date(promo.expires_at).getTime() - Date.now();
      if (diff <= 0) { setPromo(null); return; }
      const s = Math.floor(diff / 1000);
      setLeft(`${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`);
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [promo]);

  if (!promo) return null;

  return (
    <div data-testid="flash-promo-banner" className="mb-10 rounded-2xl border border-gold/50 bg-gradient-to-r from-gold/15 via-ember/10 to-gold/15 px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-3 text-center sm:text-left">
        <Zap className="w-5 h-5 text-gold animate-pulse shrink-0" />
        <p className="text-sm">
          <span className="font-display font-bold text-gold uppercase tracking-wide">{t("flash_title")}</span>{" "}
          <span className="text-mist">{t("flash_sub")}</span>{" "}
          <span className="font-mono2 font-bold text-gold tracking-widest">{promo.code}</span>
        </p>
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <span className="font-mono2 text-xl font-bold tabular-nums text-white" data-testid="flash-countdown">{left}</span>
        <Link
          to="/storie"
          data-testid="flash-cta"
          className="rounded-full bg-gold px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-black hover:bg-ember transition-colors"
        >
          {t("flash_cta")}
        </Link>
      </div>
    </div>
  );
};

export default FlashPromo;
